import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { getControlList as _getControlList, getAdminControlList as _getAdminControlList, getAdminControlHistoryList, getControlHistoryList } from '@/api/correspondence/task';
import { downloadFileByCreator, downloadHistoryFileByCreator, remove as _remove, testSingleC02, toGetEcodeDetail } from '@/api/correspondence/task/form';
import { mapState } from 'vuex';
import PopoverPreDoc from '@/components/correspondence/popover-pre-doc';
import { getEditorFileSrc } from '@/api/upload';
import { createObjectURL } from '@/util';
import { dateToCNByDayJs, toDayJs } from '@/filters';
import { getReceiversList } from '@/api/correspondence/object';
// import BaseForm from '@/views/correspondence/task/components/form.vue'
import { getList } from '@/api/setting/dictionary';
export default {
  name: 'custom-table',
  props: {
    filterListParams: {
      default: function _default() {
        return undefined;
      }
    },
    pageLoading: {
      default: function _default() {
        return false;
      }
    },
    data: {
      default: function _default() {
        return [];
      }
    },
    admin: {
      default: function _default() {
        return false;
      }
    },
    history: {
      default: function _default() {
        return false;
      }
    },
    filterKey: {
      default: function _default() {
        return undefined;
      }
    },
    filterValue: {
      default: function _default() {
        return undefined;
      }
    },
    roles: {
      default: function _default() {
        return [];
      }
    },
    id: {
      default: function _default() {
        return undefined;
      }
    },
    taskDetail: {
      default: function _default() {
        return {};
      }
    },
    // canBeEdit: {
    //   type: Boolean,
    //   default () {
    //     return false
    //   }
    // },
    isManager: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    searchQuery: {
      default: function _default() {
        return '';
      }
    }
  },
  components: {
    PopoverPreDoc: PopoverPreDoc
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('d2admin/user', ['info'])), mapState('cpscc', ['userInfo'])), {}, {
    correspondenceType: function correspondenceType() {
      return this.$store.state.cpscc.correspondenceType;
    },
    reTypes: function reTypes() {
      return this.$store.state.cpscc.reTypes;
    },
    tableWrap: function tableWrap() {
      return this.$refs.table;
    },
    _pageLoading: function _pageLoading() {
      return this.pageLoading;
    },
    _searchQuery: function _searchQuery() {
      return this.searchQuery;
    },
    _filterKey: function _filterKey() {
      return this.filterKey;
    },
    _filterValue: function _filterValue() {
      return this.filterValue;
    },
    _filterListParams: function _filterListParams() {
      return this.filterListParams;
    },
    userId: function userId() {
      if (this.userInfo && this.userInfo.data2) {
        return this.userInfo.data2.userId;
      }
      return undefined;
    },
    isCpscAdmin: function isCpscAdmin() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('函证中心管理员') && this.queryType === '1';
        }
      }
      return false;
    },
    docContentLoading: function docContentLoading() {
      return this.dataList.some(function (item) {
        return item._contentLoading;
      });
    },
    isreplyPersonnel: function isreplyPersonnel() {
      if (this.userInfo && this.userInfo.data2) {
        if (Array.isArray(this.userInfo.data2.roles)) {
          return this.userInfo.data2.roles.includes('回函操作员');
        }
      }
      return false;
    }
  }),
  data: function data() {
    return {
      formInfo: {
        id: undefined,
        uid: undefined
      },
      showDrawer: false,
      customFilterPamrms: undefined,
      multipleSelection: [],
      loading: false,
      totalPages: 0,
      dataList: [],
      pageSize: 10,
      currentPage: 1,
      maxHeight: 600,
      getHeightFlag: false,
      timer: null,
      loadingDocList: [],
      model: [],
      searchModel: {},
      searching: false,
      cusList: [],
      testModel: false,
      queryType: undefined,
      sortBy: undefined,
      sortType: undefined,
      searchLoading: false,
      initSearch: true,
      includeDate: true,
      correspondenceTypes: [],
      sampleTypes: []
    };
  },
  methods: {
    canBeEdit: function canBeEdit(item) {
      return this.isManager || Array.isArray(this.roles) && this.roles.length > 0 && !this.admin;
    },
    transformDate: function transformDate(date) {
      return dateToCNByDayJs(date, 'YYYY-MM-DD');
    },
    setLoadingItem: function setLoadingItem(id) {
      this.loadingDocList.push(id);
    },
    getDateTime: function getDateTime() {
      return "".concat(Date.now(), "-").concat(Math.random() * 1000);
    },
    setContent: function setContent(item, data, index) {
      // item._content = data;
      this.$set(this.dataList, index, _objectSpread(_objectSpread({}, item), {}, {
        _content: data,
        _contentLoading: false
      }));
    },
    handleSizeChange: function handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getList();
    },
    getFileUrl: function getFileUrl(id, name) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, arr, fileName;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return getEditorFileSrc({
                f: id
              });
            case 1:
              data = _context.v;
              arr = id.split('.');
              if (arr.length > 1 && name) {
                fileName = "".concat(name, ".").concat(arr[arr.length - 1]);
              }
              createObjectURL(data.data, fileName || id);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getEcodeDetail: function getEcodeDetail(row) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              row._loading = true;
              _context2.n = 1;
              return _this.$awaitTo(toGetEcodeDetail(row.c02Id, row.c01task.c01Id));
            case 1:
              _yield$_this$$awaitTo = _context2.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 2);
              err = _yield$_this$$awaitTo2[0];
              data = _yield$_this$$awaitTo2[1];
              row._loading = false;
              if (!err) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              _this.$notify({
                title: '获取币码详情',
                message: data.data,
                duration: 500
              });
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getFileUrl2: function getFileUrl2(row) {
      var _arguments = arguments,
        _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var download, h, notify, _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, data, arr, fileName;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              download = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
              if (!row._downloading) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              row._downloading = true;
              h = _this2.$createElement;
              notify = _this2.$notify({
                title: '下载提示',
                message: h('span', null, '数据正在生成, 请耐心等待')
              });
              _context3.n = 2;
              return _this2.$awaitTo(_this2.history ? downloadHistoryFileByCreator(row.c02Id, row.c01task.c01Id, {
                fieldName: 'c02BackConfirmFile'
              }) : downloadFileByCreator(row.c02Id, row.c01task.c01Id, {
                fieldName: 'c02BackConfirmFile'
              }));
            case 2:
              _yield$_this2$$awaitT = _context3.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 2);
              err = _yield$_this2$$awaitT2[0];
              data = _yield$_this2$$awaitT2[1];
              notify.close();
              row._downloading = false;
              if (!err) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2);
            case 3:
              arr = row.c02BackConfirmFile.split('.');
              if (arr.length > 1) {
                fileName = "".concat(row.c02ConfirmCode, "-").concat(row.c03CusName, "-\u51FD\u8BC1\u626B\u63CF\u9644\u4EF6.").concat(arr[arr.length - 1]);
              }
              createObjectURL(data, download ? fileName : undefined);
            case 4:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getSysParams: function getSysParams(item) {
      var returnStaffInfo = item.c02ReturnStaff;
      if (returnStaffInfo && returnStaffInfo.indexOf('/') !== -1) {
        returnStaffInfo = returnStaffInfo.split('/');
      }
      var returnInfo = {
        _c02ReturnStaff: Array.isArray(returnStaffInfo) && returnStaffInfo[0] ? returnStaffInfo[0] : undefined,
        _c02ReturnStaffPhone: Array.isArray(returnStaffInfo) && returnStaffInfo[1] ? returnStaffInfo[1] : undefined
      };
      return {
        cusName: item.c03CusName,
        returnAddress: item.c02ReturnAddress,
        _returnStaff: returnInfo._c02ReturnStaff,
        _returnStaffPhone: returnInfo._c02ReturnStaffPhone,
        returnFax: item.c02ReturnFax,
        returnMobile: item.c02ReturnMobile,
        returnMail: item.c02ReturnMail,
        confirmCode: item.c02ConfirmCode,
        officeName: this.taskDetail.c01OfficeName,
        startDate: this.$options.filters.dateToCNByDayJs(this.taskDetail.c01StartDate),
        endDate: this.$options.filters.dateToCNByDayJs(this.taskDetail.c01EndDate),
        _startDate: this.taskDetail.c01EndDate,
        _endDate: this.taskDetail.c01EndDate,
        taskCusName: this.taskDetail.c01CusName,
        c02AuditCompany: item.c02AuditCompany
      };
    },
    toTest: function toTest(row, type, msg) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _yield$_this3$$awaitT, _yield$_this3$$awaitT2, err;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this3.$confirm("\u786E\u5B9A".concat(msg, "?"));
            case 1:
              _this3.loading = true;
              _context4.n = 2;
              return _this3.$awaitTo(testSingleC02(_this3.id, {
                operation: type,
                c02Id: row.c02Id
              }));
            case 2:
              _yield$_this3$$awaitT = _context4.v;
              _yield$_this3$$awaitT2 = _slicedToArray(_yield$_this3$$awaitT, 1);
              err = _yield$_this3$$awaitT2[0];
              _this3.loading = false;
              if (!err) {
                _context4.n = 3;
                break;
              }
              return _context4.a(2);
            case 3:
              _this3.$message.success('操作成功');
              _this3.getList();
            case 4:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getList: function getList() {
      var _arguments2 = arguments,
        _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var params;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              params = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {};
              _this4.multipleSelection = [];
              _this4.loadingDocList = [];
              _this4.initSearch = false;
              _this4.dataList = [];
              if (_this4.customFilterPamrms) {
                if (_this4._searchQuery) {
                  params.SearchQuery = "".concat(_this4.customFilterPamrms, " and ").concat(_this4._searchQuery);
                } else {
                  params.SearchQuery = _this4.customFilterPamrms;
                }
              }
              if (!_this4.id) {
                _context5.n = 2;
                break;
              }
              _context5.n = 1;
              return _this4.getControlList(params);
            case 1:
              _context5.n = 3;
              break;
            case 2:
              if (!_this4.admin) {
                _context5.n = 3;
                break;
              }
              _context5.n = 3;
              return _this4.getAdminControlList(params);
            case 3:
              if (!_this4.getHeightFlag) {
                _context5.n = 4;
                break;
              }
              return _context5.a(2);
            case 4:
              _this4.$nextTick(function () {
                _this4.getHeight();
              });
            case 5:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    remove: function remove(item) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _yield$_this5$$awaitT, _yield$_this5$$awaitT2, err, data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this5.$$confirm('确定删除?');
            case 1:
              _this5.loading = true;
              _context6.n = 2;
              return _this5.$awaitTo(_remove(item.c02Id, _this5.id));
            case 2:
              _yield$_this5$$awaitT = _context6.v;
              _yield$_this5$$awaitT2 = _slicedToArray(_yield$_this5$$awaitT, 2);
              err = _yield$_this5$$awaitT2[0];
              data = _yield$_this5$$awaitT2[1];
              _this5.loading = false;
              if (!err) {
                _context6.n = 3;
                break;
              }
              return _context6.a(2);
            case 3:
              _this5.$message.success('操作成功');
              _this5.getList();
            case 4:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    edit: function edit(item) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _this6.$router.push("/correspondence/task/".concat(_this6.history ? 'history-form' : 'form', "/").concat(item.c02C01Id, "/").concat(item.c02Id, "?type=").concat(_this6.admin ? 1 : 2, "&tabTitle=").concat(item.c02ConfirmCode, "&status=").concat(item.c01task.c01TaskState));
              // this.formInfo.id = item.c02C01Id
              // this.formInfo.uid = item.c02Id
              // this.formInfo.formType = this.admin ? '1' : '2'
              // this.formInfo.tabTitle = item.c02ConfirmCode
              // await this.$nextTick()
              // this.showDrawer = true
            case 1:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.currentPage = page;
      this.getList(params);
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$emit('change', val);
    },
    getHeight: function getHeight() {
      var _this7 = this;
      clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        var body = document.querySelector('.d2-container-full__body');
        _this7.maxHeight = body.scrollHeight - 100;
        _this7.getHeightFlag = true;
      }, 500);
    },
    getAdminControlList: function getAdminControlList() {
      var _arguments3 = arguments,
        _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var params, config, _yield$_this8$$awaitT, _yield$_this8$$awaitT2, err, res, headers, data, pagination, item;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              params = _arguments3.length > 0 && _arguments3[0] !== undefined ? _arguments3[0] : {};
              _this8.loading = true;
              config = _objectSpread({
                PageNumber: _this8.currentPage,
                PageSize: _this8.pageSize,
                SearchQuery: _this8._searchQuery,
                sortBy: _this8.sortBy
              }, params);
              _context8.n = 1;
              return _this8.$awaitTo(_this8.history ? getAdminControlHistoryList(config) : _getAdminControlList(config));
            case 1:
              _yield$_this8$$awaitT = _context8.v;
              _yield$_this8$$awaitT2 = _slicedToArray(_yield$_this8$$awaitT, 2);
              err = _yield$_this8$$awaitT2[0];
              res = _yield$_this8$$awaitT2[1];
              _this8.loading = false;
              console.log(res);
              if (!err) {
                _context8.n = 2;
                break;
              }
              return _context8.a(2, Promise.reject());
            case 2:
              headers = res.headers, data = res.data;
              if (Array.isArray(data)) {
                _this8.dataList = data.map(function (sub) {
                  return _objectSpread(_objectSpread({}, sub), {}, {
                    _content: '',
                    _contentLoading: !!sub.c02Confirm,
                    _loading: false,
                    _downloading: false
                  });
                });
              }
              pagination = headers['x-pagination'];
              if (pagination) {
                _this8.totalPages = JSON.parse(pagination).totalCount;
              }
              if (params.toDetail && _this8.dataList.length === 1) {
                item = _this8.dataList[0];
                _this8.edit(item);
              }
              return _context8.a(2, Promise.resolve());
          }
        }, _callee8);
      }))();
    },
    getControlList: function getControlList() {
      var _arguments4 = arguments,
        _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var params, options, _yield$_this9$$awaitT, _yield$_this9$$awaitT2, err, res, headers, data, pagination, item;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              params = _arguments4.length > 0 && _arguments4[0] !== undefined ? _arguments4[0] : {};
              _this9.loading = true;
              options = _objectSpread({
                PageNumber: _this9.currentPage,
                PageSize: _this9.pageSize,
                SearchQuery: _this9._searchQuery,
                sortBy: _this9.sortBy
              }, params);
              _context9.n = 1;
              return _this9.$awaitTo(_this9.history ? getControlHistoryList(_this9.id, options) : _getControlList(_this9.id, options));
            case 1:
              _yield$_this9$$awaitT = _context9.v;
              _yield$_this9$$awaitT2 = _slicedToArray(_yield$_this9$$awaitT, 2);
              err = _yield$_this9$$awaitT2[0];
              res = _yield$_this9$$awaitT2[1];
              _this9.loading = false;
              if (!err) {
                _context9.n = 2;
                break;
              }
              return _context9.a(2, Promise.reject());
            case 2:
              headers = res.headers, data = res.data;
              if (Array.isArray(data)) {
                _this9.dataList = data.map(function (sub) {
                  return _objectSpread(_objectSpread({}, sub), {}, {
                    _content: '',
                    _contentLoading: !!sub.c02Confirm,
                    _loading: false,
                    _downloading: false
                  });
                });
              }
              pagination = headers['x-pagination'];
              if (pagination) {
                _this9.totalPages = JSON.parse(pagination).totalCount;
              }
              if (params.toDetail && _this9.dataList.length === 1) {
                item = _this9.dataList[0];
                _this9.edit(item);
              }
              return _context9.a(2, Promise.resolve());
          }
        }, _callee9);
      }))();
    },
    bindModel: function bindModel(key, value) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'contains';
      this.searchModel[key] = {
        key: key,
        value: value,
        type: type,
        codes: undefined
      };
    },
    onSearch: function onSearch() {
      var _this0 = this;
      var query = [];
      for (var k in this.searchModel) {
        if (this.searchModel[k].value) {
          query.push(this.searchModel[k]);
        }
      }
      var searchQuery = query.map(function (item) {
        if (item.type === '=') {
          return "".concat(item.key, " == ").concat(typeof item.value === 'number' ? item.value : "\"".concat(item.value, "\""));
        } else if (item.type === 'in' && Array.isArray(item.codes) && item.codes.length) {
          return "".concat(item.key, " in (").concat(item.codes.join(','), ")");
        } else if (item.type === 'between' && Array.isArray(item.value) && item.value.length === 2) {
          return "".concat(item.key, " >= \"").concat(item.value[0], "\" and ").concat(item.key, " <= \"").concat(item.value[1], "\"");
        } else if (item.type === 'month' && item.value) {
          return "".concat(item.key, ".contains(\"").concat(toDayJs(item.value).format(_this0.includeDate ? 'YYYY-MM-DD' : 'YYYY-MM'), "\")");
        }
        return "".concat(item.key, ".contains(").concat(typeof item.value === 'number' ? item.value : "\"".concat(item.value, "\""), ")");
      });
      if (searchQuery.length) {
        this.customFilterPamrms = searchQuery.join(' and ');
      } else {
        this.customFilterPamrms = undefined;
      }
      this.currentPage = 1;
      this.getList();
    },
    remoteMethod: function remoteMethod(query, key) {
      var _this1 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        var _yield$_this1$$awaitT, _yield$_this1$$awaitT2, err, res, data;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              if (!_this1.searchLoading) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              _this1.cusList = [];
              if (!(query !== '' && query !== undefined)) {
                _context0.n = 4;
                break;
              }
              _this1.searchLoading = true;
              _context0.n = 2;
              return _this1.$awaitTo(getReceiversList({
                PageNumber: 1,
                PageSize: 50,
                SearchQuery: "c03CusName.contains(\"".concat(query, "\")")
              }));
            case 2:
              _yield$_this1$$awaitT = _context0.v;
              _yield$_this1$$awaitT2 = _slicedToArray(_yield$_this1$$awaitT, 2);
              err = _yield$_this1$$awaitT2[0];
              res = _yield$_this1$$awaitT2[1];
              _this1.searchLoading = false;
              if (!err) {
                _context0.n = 3;
                break;
              }
              return _context0.a(2);
            case 3:
              data = res.data;
              if (Array.isArray(data)) {
                _this1.cusList = data.map(function (item) {
                  return "\"".concat(item.c03Id, "\"");
                });
              }
            case 4:
              _this1.searchModel[key].codes = _this1.cusList;
              _this1.onSearch();
              // this.cusList = []
              // if (query !== '' && query !== undefined) {
              //   this.searchLoading = true
              //   const [err, res] = await this.$awaitTo(getReceiversList({
              //     PageNumber: 1,
              //     PageSize: 50,
              //     SearchQuery: `c03CusName.contains("${query}")`
              //   }))
              //   this.searchLoading = false
              //   if (err) {
              //     return
              //   }
              //   const { data } = res
              //   if (Array.isArray(data)) {
              //     this.cusList = data
              //   }
              // }
            case 5:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    sortChange: function sortChange(key) {
      if (this.sortType) {
        if (this.sortType === 'desc') {
          this.sortType = 'asc';
        } else {
          this.sortType = undefined;
        }
      } else {
        this.sortType = 'desc';
      }
      if (this.sortType) {
        this.sortBy = "".concat(key, " ").concat(this.sortType);
      } else {
        this.sortBy = undefined;
      }
      this.handleCurrentChange(1);
    },
    changeCusName: function changeCusName(key, value) {
      this.bindModel(key, value, '=');
      this.onSearch();
    },
    searchDate: function searchDate(key, value) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '=';
      this.bindModel(key, value, type);
      this.onSearch();
    },
    getOptions: function getOptions(type, key) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var _yield$_this10$$await, _yield$_this10$$await2, err, data;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              _context1.n = 1;
              return _this10.$awaitTo(getList({
                page: 1,
                length: 99999,
                type: type
              }));
            case 1:
              _yield$_this10$$await = _context1.v;
              _yield$_this10$$await2 = _slicedToArray(_yield$_this10$$await, 2);
              err = _yield$_this10$$await2[0];
              data = _yield$_this10$$await2[1].data;
              if (!err) {
                _context1.n = 2;
                break;
              }
              return _context1.a(2, Promise.reject());
            case 2:
              if (Array.isArray(data.datas)) {
                _this10[key] = data.datas;
              }
              return _context1.a(2, Promise.resolve());
          }
        }, _callee1);
      }))();
    }
  },
  mounted: function mounted() {
    if (!this.admin) {
      this.getList();
    }
    this.getOptions('c02SampleType', 'sampleTypes');
    this.getOptions('c02SendType', 'correspondenceTypes');
  },
  created: function created() {
    var _this$$route$query = this.$route.query,
      type = _this$$route$query.type,
      testModel = _this$$route$query.testModel;
    this.queryType = type;
    this.testModel = testModel;
  }
};